<template>
  <BreadCrumb PageTitle="Webhook" />
  <WebhookSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import WebhookSettings from "@/components/Generals/DocAPI/WebhookSettings.vue";

export default defineComponent({
  name: "WebhookPage",
  components: {
    BreadCrumb,
    WebhookSettings,
  },
});
</script>